// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"cda3545f","986":"b9f40019"}[chunkId] + ".chunk.js";
};